import { useContext } from "react";

import { ClinicaContext } from "../../../shared/context/clinica-context";

/**
 * Diz se o que se configura neste separador é partilhado entre as unidades ou
 * pertence só a uma.
 *
 * É a pergunta que toda a gente faz ao configurar seja o que for numa clínica
 * com dois locais — «isto vale para as duas?» — e a resposta não estava em lado
 * nenhum. Está aqui num sítio só para as catorze respostas serem coerentes: com
 * catorze frases escritas à mão, bastava uma ficar desatualizada para plantar a
 * dúvida em todas.
 *
 * Não aparece nas clínicas de unidade única: aí a pergunta não existe.
 *
 * @param {boolean} porUnidade  true = cada unidade tem os seus
 */
const NotaPartilhaUnidades = ({ porUnidade = false }) => {
  const clinica = useContext(ClinicaContext);

  if (!clinica?.clinica?.multiEstabelecimento) return null;

  return (
    <li>
      {porUnidade ? (
        <>
          <strong>Cada unidade tem os seus.</strong> Está a ver apenas os da
          unidade onde está a trabalhar, e o que criar aqui nasce nessa unidade.
          Para gerir os do outro local, mude de unidade no indicador junto ao seu
          nome.
        </>
      ) : (
        <>
          <strong>São partilhados por todas as unidades.</strong> O que alterar
          aqui vale para a clínica inteira, independentemente da unidade onde
          estiver a trabalhar.
        </>
      )}
    </li>
  );
};

export default NotaPartilhaUnidades;
